const feedbacksTemplate = function (
  template_brand,
  template_flow_name,
  template_version,
  template_display_Brand,
  template_primary_color,
  template_logo_link
) {
  const template = {
    brand: template_brand,
    app: "web-app",
    name: template_flow_name,
    version: template_version,
    nodes: [
      {
        width: 191,
        height: 119,
        id: "7232711-4f84-0ee6-7843-1188ef7b37",
        type: "basic",
        position: { x: 2846.804577113582, y: 976.5134388423812 },
        data: {
          handles: 2,
          name: "analyse",
          module: {
            options: {
              type: "AlloBrain",
              field_id: "sentiment",
              description: "Analyse de du sentiment",
              mandatory: true,
            },
            parameters: {
              data: '{\n  "text": {\n    "$": {\n      "var": "answers.verbatim.text"\n    }\n  },\n  "language": "fr"\n}',
              process_id: "global-sentiment-analysis",
              message: {
                fr: "Analyse en cours ...",
                en: "Analysis in progress...",
              },
              synchronous: true,
            },
          },
          starter: false,
          id: "7232711-4f84-0ee6-7843-1188ef7b37",
        },
        nextNodeListConditions: [
          "reactflow__edge-7232711-4f84-0ee6-7843-1188ef7b37-d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        ],
        positionAbsolute: { x: 2846.804577113582, y: 976.5134388423812 },
        z: 968,
        zIndex: 998,
        dragging: false,
      },
      {
        width: 150,
        height: 97,
        id: "0c3f42-c043-31f6-5723-5ab05d1cbe5",
        type: "basic",
        position: { x: 2873.908909685763, y: 814.0878936732596 },
        data: {
          handles: 2,
          name: "AsyncAnalysis",
          module: {
            options: { type: "AlloBrain", mandatory: true },
            parameters: {
              data: '{\n  "verbatim": {\n    "$": {\n      "var": "answers.verbatim.text"\n    }\n  },\n  "brand": "template",\n  "id": {\n    "$": {\n      "var": "store.id"\n    }\n  }\n}',
              message: { fr: "Un instant s'il vous plaît ..." },
              process_id: "fully_unsupervised_analysis",
            },
          },
          starter: false,
          id: "0c3f42-c043-31f6-5723-5ab05d1cbe5",
        },
        nextNodeListConditions: [
          "reactflow__edge-0c3f42-c043-31f6-5723-5ab05d1cbe5-7232711-4f84-0ee6-7843-1188ef7b37",
        ],
        zIndex: 977,
        positionAbsolute: { x: 2873.908909685763, y: 814.0878936732596 },
      },
      {
        width: 150,
        height: 97,
        id: "d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        type: "basic",
        position: { x: 2868.580714590871, y: 1166.8201220352653 },
        data: {
          handles: 2,
          name: "SyncAnalysis",
          module: {
            options: {
              type: "AlloBrain",
              field_id: "analysis",
              mandatory: true,
            },
            parameters: {
              data: '{\n  "text": {\n    "$": {\n      "var": "answers.verbatim.text"\n    }\n  },\n  "language": {\n    "$": {\n      "var": "answers.verbatim.language"\n    }\n  }\n}',
              message: {
                en: "Analysis in progress...",
                fr: "Un instant ...",
              },
              process_id: "generic-webapp-answerer",
              synchronous: true,
            },
          },
          starter: false,
          id: "d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        },
        nextNodeListConditions: [
          "reactflow__edge-d7e1c0f-b5a2-a8ed-bd44-444544fcbc-3d856a6-a4e-c16-17-1d52b67a774d",
        ],
        zIndex: 988,
        positionAbsolute: { x: 2868.580714590871, y: 1166.8201220352653 },
      },
      {
        width: 180,
        height: 97,
        id: "3d856a6-a4e-c16-17-1d52b67a774d",
        type: "basic",
        position: { x: 2864.18810603034, y: 1364.8532246317302 },
        data: {
          handles: 2,
          name: "Thank You Others",
          module: {
            options: { type: "PostMessage", mandatory: true },
            parameters: {
              message: {
                is_code: true,
                code: '{\n  "$": {\n    "var": "answers.analysis.answer"\n  }\n}',
              },
              icon: "🚀",
            },
          },
          starter: false,
          id: "3d856a6-a4e-c16-17-1d52b67a774d",
        },
        nextNodeListConditions: [],
        positionAbsolute: { x: 2864.18810603034, y: 1364.8532246317302 },
        z: 997,
        dragging: false,
        zIndex: 996,
      },
      {
        width: 153,
        height: 97,
        id: "d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        type: "basic",
        position: { x: 2872.327061359193, y: 634.790471984759 },
        data: {
          handles: 2,
          name: "verbatim",
          module: {
            options: {
              type: "AlloMicro",
              field_id: "verbatim",
              mandatory: true,
            },
            parameters: {
              title: {
                fr: "Partagez avec nous votre expérience librement ! ",
                en: "Share your experience with us freely! ",
              },
              audio_only: false,
              more_info: {
                sentence: {
                  code: {
                    fr: "Votre voix reste confidentielle",
                    en: "Your voice remain confidential ",
                  },
                  is_code: true,
                },
              },
              promptUserMicrophone: {
                title: {
                  fr: "Pour que vous puissiez nous parler, une autorisation du microphone est nécessaire",
                  en: "In order for you to talk to us, a microphone authorization is required",
                },
                body: {
                  fr: "Une fenêtre comme celle-ci va apparaître, il faudra cliquer sur “Autoriser”",
                  en: 'A pop-up like this one will appear, click on "Authorize".',
                },
                button: { fr: "J'ai compris", en: "I understood" },
                imageSource:
                  "https://uploads-ssl.webflow.com/61c1d51530aa085035274109/63bd90478a647976cecc971e_Group%2031%20(1).png",
              },
              write_feedback_title: {
                fr: "Parlez-nous de votre expérience ! ",
                en: "Tell us about your experience! ",
              },
              write_feedback_button_text: {
                fr: "Je préfère écrire",
                en: "I prefer to write",
              },
              select_transcript_language: true,
            },
          },
          starter: false,
          id: "d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        },
        nextNodeListConditions: [
          "reactflow__edge-d5c2ac3-dd77-531e-0fd-8f5ba26d7d4-0c3f42-c043-31f6-5723-5ab05d1cbe5",
        ],
        positionAbsolute: { x: 2872.327061359193, y: 634.790471984759 },
        z: 978,
        dragging: false,
        zIndex: 1000,
      },
      {
        width: 220,
        height: 97,
        id: "63d772-770-377e-52e6-337adc5ddfb4",
        type: "basic",
        position: { x: 2839.791659652693, y: 483.5704871042883 },
        data: {
          handles: 2,
          name: "welcome",
          module: {
            options: { type: "PreMessageSimple", mandatory: true },
            parameters: {
              button: { fr: "Suivant", en: "Next" },
              title: {
                fr:
                  "Que pensez-vous de votre dernière expérience avec " +
                  template_display_Brand +
                  "?",
                en:
                  "What do you think of your last experience with " +
                  template_display_Brand +
                  "?",
              },
              text: {
                fr: "Il vous suffit de nous en parler, tout simplement et librement !",
                en: "Just tell us about it, simply and freely!",
              },
            },
          },
          starter: true,
          id: "63d772-770-377e-52e6-337adc5ddfb4",
        },
        nextNodeListConditions: [
          "reactflow__edge-63d772-770-377e-52e6-337adc5ddfb4-d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        ],
        positionAbsolute: { x: 2839.791659652693, y: 483.5704871042883 },
        z: 954,
        dragging: false,
        zIndex: 993,
      },
    ],
    edges: [
      {
        source: "d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        sourceHandle: "a",
        target: "0c3f42-c043-31f6-5723-5ab05d1cbe5",
        targetHandle: null,
        id: "reactflow__edge-d5c2ac3-dd77-531e-0fd-8f5ba26d7d4-0c3f42-c043-31f6-5723-5ab05d1cbe5",
        type: "conditionalEdge",
        label: "unconditional",
        markerEnd: { type: "arrowclosed", color: "#f6003c" },
        style: { stroke: "#f6003c", strokeWidth: 2, strokeOpacity: 0.7 },
        data: { condition: "" },
      },
      {
        source: "63d772-770-377e-52e6-337adc5ddfb4",
        sourceHandle: "a",
        target: "d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        targetHandle: null,
        id: "reactflow__edge-63d772-770-377e-52e6-337adc5ddfb4-d5c2ac3-dd77-531e-0fd-8f5ba26d7d4",
        type: "conditionalEdge",
        label: "unconditional",
        markerEnd: { type: "arrowclosed", color: "#f6003c" },
        style: { stroke: "#f6003c", strokeWidth: 2, strokeOpacity: 0.7 },
        data: { condition: "" },
      },
      {
        source: "0c3f42-c043-31f6-5723-5ab05d1cbe5",
        sourceHandle: "a",
        target: "7232711-4f84-0ee6-7843-1188ef7b37",
        targetHandle: null,
        id: "reactflow__edge-0c3f42-c043-31f6-5723-5ab05d1cbe5-7232711-4f84-0ee6-7843-1188ef7b37",
        type: "conditionalEdge",
        label: "unconditional",
        markerEnd: { type: "arrowclosed", color: "#f6003c" },
        style: { stroke: "#f6003c", strokeWidth: 2, strokeOpacity: 0.7 },
        data: { condition: "" },
      },
      {
        source: "7232711-4f84-0ee6-7843-1188ef7b37",
        sourceHandle: "a",
        target: "d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        targetHandle: null,
        id: "reactflow__edge-7232711-4f84-0ee6-7843-1188ef7b37-d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        type: "conditionalEdge",
        label: "unconditional",
        markerEnd: { type: "arrowclosed", color: "#f6003c" },
        style: { stroke: "#f6003c", strokeWidth: 2, strokeOpacity: 0.7 },
        data: { condition: "" },
      },
      {
        source: "d7e1c0f-b5a2-a8ed-bd44-444544fcbc",
        sourceHandle: "a",
        target: "3d856a6-a4e-c16-17-1d52b67a774d",
        targetHandle: null,
        id: "reactflow__edge-d7e1c0f-b5a2-a8ed-bd44-444544fcbc-3d856a6-a4e-c16-17-1d52b67a774d",
        type: "conditionalEdge",
        label: "unconditional",
        markerEnd: { type: "arrowclosed", color: "#f6003c" },
        style: { stroke: "#f6003c", strokeWidth: 2, strokeOpacity: 0.7 },
        data: { condition: "" },
      },
    ],
    viewport: {
      x: -1380.154437494332,
      y: -308.69587789833986,
      zoom: 0.7103701918898091,
    },
    globalParameters: {
      configs: {
        theme: "light",
        languages: [{ value: "fr", name: "Français" }],
        stt_languages: ["fr-FR"],
        primaryColor: template_primary_color,
        logo: template_logo_link,
      },
    },
    editionInProgress: false,
    flowLoaded: true,
    mouseOverPane: false,
  };

  return template;
};

export default feedbacksTemplate;
